import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Tab, Typography } from '@mui/material';
import { BatchPutTemplate } from '../BatchGet';
import { TabPanel } from '@mui/lab';
import { camelToDisplay } from '@iotv/datamodel-core';
import { TabContext, TabList } from '@mui/lab';
import { CustomerDevices } from './WideawakeTabs/CustomerDevices';
import { useState } from 'react';
import { ItemMetadata } from './WideawakeTabs/ItemMetadata';
import { GetItem } from './WideawakeTabs/GetItem';
export const Wideawake = ({ value }) => {
    const tabsToDisplay = {
        Devices: (value) => (_jsx(TabPanel, { value, children: _jsx(CustomerDevices, {}) }, value)),
        ItemMetadata: (value) => (_jsx(TabPanel, { value, children: _jsx(ItemMetadata, {}) }, value)),
        GetItem: (value) => (_jsx(TabPanel, { value, children: _jsx(GetItem, {}) }, value)),
        BatchPutTemplate: (value) => (_jsx(TabPanel, { value, children: _jsx(BatchPutTemplate, {}) }, value)),
    };
    const [tab2Idx, setTab2Idx] = useState(0);
    const getTabName = (idx) => Object.keys(tabsToDisplay)[idx];
    const getTabIndex = (str) => Object.keys(tabsToDisplay).indexOf(str);
    return (_jsxs(TabPanel, { value, children: [_jsx(Typography, { variant: 'h6', children: "Wideawake" }), _jsxs(TabContext, { value: getTabName(tab2Idx), children: [_jsx(TabList, { onChange: (e, newTabName) => setTab2Idx(getTabIndex(newTabName)), children: Object.keys(tabsToDisplay).map((k) => (_jsx(Tab, { label: camelToDisplay(k), value: k }, k))) }), Object.entries(tabsToDisplay).map(([k, fn]) => fn(k))] })] }, 'Wideawake'));
};
